import { gql } from '@apollo/client';

const GET_ORIGINAL_ORDER = gql`
  query getOriginalOrder($orderId: String, $email: String) {
    originalOrder(orderId: $orderId, email: $email) {
      orderId
      orderToken
      orderItems {
        currency
        partNumber
        primeLineKey
        productId
        itemPriceFmt
        itemPricePaidFmt
        orderLineKey
        orderItemToken
        color
        salesTaxFmt
        shippingTaxFmt
        size
        name
        imageId
        finalSaleItem
        returnable
        exchangeable
        returnDetails {
          returnOrderNumber
        }
        collection
        gcFacePlateImageUrl
        isHazmat
        status
        statusKey
        statusText
        returned
      }
      eligibleForReturn {
        currency
        partNumber
        primeLineKey
        productId
        itemPriceFmt
        itemPricePaidFmt
        orderLineKey
        orderItemToken
        color
        salesTaxFmt
        shippingTaxFmt
        size
        name
        imageId
        finalSaleItem
        returnable
        exchangeable
        returnDetails {
          returnOrderNumber
        }
        collection
        gcFacePlateImageUrl
        isHazmat
        bucket
        status
        statusKey
        statusText
        returned
      }
      ineligibleForReturn {
        currency
        partNumber
        primeLineKey
        productId
        itemPriceFmt
        itemPricePaidFmt
        orderLineKey
        orderItemToken
        color
        salesTaxFmt
        shippingTaxFmt
        size
        name
        imageId
        finalSaleItem
        returnable
        exchangeable
        returnDetails {
          returnOrderNumber
        }
        collection
        gcFacePlateImageUrl
        isHazmat
        bucket
        status
        statusKey
        statusText
        returned
      }
      orderDetails {
        billToKey
        currency
        email
        refundTenderType
        returnFeeWaived
        returnShippingFee
        shipToKey
        totalPaidPriceFmt
        orderLineItems {
          shortSku
        }
        payments {
          cardType
          cardNumber
          cardExpirationDate
          paymentName
        }
        shippingAddress {
          firstName
          lastName
          address1
          address2
          addressId
          postalCode
          city
          state
          country
        }
      }
      valueTierTealiumKey {
        key
        havingSubBrand
        subBrandKey
      }
    }
    googleApiKey
    returnReasonCodeList {
      label
      value
      type
      id
      options {
        id
        label
        type
        value
      }
    }
    returnReasons {
      ...ReasonCodeLevel1
    }
  }

  fragment ReasonCodeLevel1 on ReasonCode {
    name
    level
    code
    fault
    final
    children {
      ...ReasonCodeLevel2
    }
  }

  fragment ReasonCodeLevel2 on ReasonCode {
    name
    code
    level
    fault
    final
    children {
      ...ReasonCodeLevel3
    }
  }

  fragment ReasonCodeLevel3 on ReasonCode {
    name
    code
    fault
    final
    children {
      ...ReasonCodeLevel4
    }
  }

  fragment ReasonCodeLevel4 on ReasonCode {
    name
    code
    level
    fault
    final
    children {
      ...ReasonCodeLevel5
    }
  }

  fragment ReasonCodeLevel5 on ReasonCode {
    name
    code
    level
    fault
    final
  }
`;

export default GET_ORIGINAL_ORDER;